module.exports = JSON.parse('{"Load files":"Charger des fichiers","Load folders":"Charger des dossiers"}')